export class DialogModelUnBlockUser {
    constructor(
      public mobile: any
    ) {}
  }
  